(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sinner-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const parallaxContainer = document.querySelector('.sinner-parallax-container');
    const title = document.querySelector('.sinner-title');
    const marla = document.querySelector('.sinner-parallax-marla');
    const men = document.querySelector('.sinner-parallax-men');
    
    if (!parallaxContainer || !title || !marla || !men) return;
    
    function updateElements() {
      const scrolled = parallaxContainer.scrollTop;
      
      // Title effect
      const maxScroll = 1000;
      const scrollProgress = Math.min(scrolled / maxScroll, 1);
      
      // Scale grows from 1 to 3 as you scroll
      const titleScale = 1 + (scrollProgress * 12);
      
      // Opacity decreases from 1 to 0 as you scroll
      const opacity = Math.max(1 - (scrollProgress * 8), 0);
      
      title.style.transform = `translateX(-5%) scale(${titleScale})`;
      title.style.opacity = opacity;
      
      // Marla effect - scale increases as you scroll
      const marlaMaxScroll = 2000;
      const marlaScrollProgress = Math.min(scrolled / marlaMaxScroll, 1);
      const marlaScale = 1.5 + (marlaScrollProgress);
      const menScale = 1.8 - (marlaScrollProgress * 0.5);
      marla.style.transform = `translateX(-50%) translateZ(-0.5px) scale(${marlaScale})`;
      men.style.transform = `translateX(-50%) translateZ(-0.9px) scale(${menScale})`;
    }
    
    parallaxContainer.addEventListener('scroll', updateElements);
    
    // Make vases clickable to disappear
    const vases = document.querySelectorAll('.sinner-parallax-foreground-vase');
    vases.forEach(function(vase) {
      vase.addEventListener('click', function() {
        this.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
        this.style.opacity = '0';
        this.style.transform += ' scale(0.8)';
        
        // Remove from DOM after animation completes
        setTimeout(() => {
          this.style.display = 'none';
        }, 500);
      });
      
      // Add cursor pointer to indicate clickability
      vase.style.cursor = 'pointer';
      vase.style.pointerEvents = 'auto';
    });
  });

  } catch(e) { console.error(e); }
})();
})();
